import React from 'react';
import './AribaContent.css';
import Ariba from '../../assets/images/Ariba.png';


const AribaContent = () => {
  return (
    <section className="ariba-page-content-section">
      <div className="container">
        {/* Top Intro Section */}
        <div className="ariba-intro-grid">
          <div className="ariba-intro-image-container">
            <img 
              src={Ariba}
              className="ariba-intro-image"
            />
          </div>
          <div className="ariba-intro-text">
            <h2 className="ariba-intro-title">Streamline Procurement with SAP Ariba Implementation</h2>
            <p>
              Neuroverse AI offers comprehensive SAP Ariba consulting services in the USA, specializing in end-to-end procurement solutions. Our expert team provides tailored SAP Ariba implementation services, ensuring seamless integration with your existing systems. As a leading SAP Ariba consulting company, we deliver strategic guidance to optimize your procurement processes.
            </p>
          </div>
        </div>

        {/* Features Grid Section */}
        <div className="ariba-features-grid">
          <div className="ariba-feature-card">
            <h3>Best SAP Ariba Course Online: Learn from Industry Experts</h3>
            <p>
              For those interested in mastering SAP Ariba, enrolling in the Best SAP Ariba Course Online is the best way to gain in-depth knowledge of this powerful tool. The course covers the fundamental to advanced features of SAP Ariba.
            </p>
          </div>
          <div className="ariba-feature-card">
            <h3>Beginner-Friendly SAP Ariba</h3>
            <p>
              For newcomers to SAP Ariba or procurement, the Online SAP Ariba Course for Beginners is a great starting point. This course simplifies the SAP Ariba platform’s complexities and helps you understand the core features of procurement systems.
            </p>
          </div>
          <div className="ariba-feature-card">
            <h3>Advanced Services for Business Professionals</h3>
            <p>
              For more experienced users or those in leadership positions, SAP Ariba Course for Business Professionals offers an in-depth understanding of the platform’s strategic benefits. This course delves into SAP Ariba’s advanced capabilities.
            </p>
          </div>
          <div className="ariba-feature-card">
            <h3>SAP Ariba Implementation Services for Businesses</h3>
            <p>
              If your organisation plans to implement SAP Ariba, SAP Ariba Implementation Services can guide you through configuring, deploying, and optimising the system to suit your business needs. These services help businesses align SAP Ariba’s features with their procurement goals.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AribaContent;
